(() => {
 'use strict';
 const tag=document.querySelector('[data-lds-sill-native-adapter]');
 if(!tag)return;
 const config=JSON.parse(document.querySelector('[data-lds-sill-config]').textContent);
 const root=document.querySelector(`[data-product-id="${config.productId}"]`);
 const picker=root?.querySelector('hdt-variant-picker');
 const form=picker&&document.forms[picker.getAttribute('form')];
 const gallery=picker&&root.querySelector(`hdt-product-media[form="${picker.getAttribute('form')}"]`);
 if(!root||!picker||!form||!gallery)return;
 const variants=JSON.parse(document.querySelector('[data-lds-sill-native-variants]').textContent);
 const initialize=async()=>{
  await Promise.all(['hdt-variant-picker','hdt-product-media','hdt-slider'].map(name=>customElements.whenDefined(name)));
  const slider=gallery.querySelector('.hdt-product-media__main hdt-slider');
  const media=gallery.querySelector('.hdt-product-media__main');
  const slides=[...slider?.querySelectorAll('.hdt-slider__slide')||[]];
  const first=slides.find(slide=>slide.querySelector('img')?.src.includes(config.expectedMediaStem));
  if(!slider||!media||!first||typeof picker.selectVariantByID!=='function')return;
  if(picker.hasAttribute('no-pick'))return;
  let pickerReady=false;
  for(let attempt=0;attempt<100;attempt++){
   if(picker.masterInput instanceof HTMLInputElement&&typeof picker.getvariantObjById==='function'&&picker.getvariantObjById(picker.masterInput.value)){pickerReady=true;break;}
   await new Promise(resolve=>setTimeout(resolve,100));
  }
  if(!pickerReady)return;
  let sliderReady=false;
  for(let attempt=0;attempt<50;attempt++){
   try{if(typeof slider.isActive==='boolean'){sliderReady=true;break;}}catch{}
   await new Promise(resolve=>setTimeout(resolve,100));
  }
  if(!sliderReady)return;
  root.dataset.ldsSillNative='';form.dataset.ldsForm='';media.dataset.ldsMainMedia='';
  const add=root.querySelector(`button[name="add"][form="${picker.getAttribute('form')}"]`)||form.querySelector('button[name="add"]');if(add)add.dataset.ldsAdd='';
  const price=root.querySelector(`hdt-price[form="${picker.getAttribute('form')}"]`);if(price)price.dataset.ldsPrice='';
  const variantNode=document.createElement('script');variantNode.type='application/json';variantNode.dataset.ldsVariants='';variantNode.textContent=JSON.stringify(variants);root.append(variantNode);
  for(const [index,slide]of slides.entries()){slide.dataset.ldsSlide='';slide.dataset.mediaIndex=String(index);slide.style.position='relative';}
  const marker=document.createElement('span');marker.hidden=true;marker.dataset.ldsFirstImage='';first.append(marker);
  const activate=(selected)=>{for(const slide of slides)slide.classList.toggle('is-active',slide===selected);};
  activate(config.fordSourceSync?(slides.find(slide=>slide.classList.contains('is-in-view')||slide.classList.contains('is-selected'))||first):first);
  slider.addEventListener('select:slide',event=>{
   const api=event.detail?.sliderApi;
   if(api&&typeof api.selectedScrollSnap==='function')activate(api.slideNodes()[api.selectedScrollSnap()]);
  });
  const thumb=document.createElement('button');thumb.type='button';thumb.hidden=true;thumb.dataset.ldsThumb='';thumb.dataset.mediaIndex=String(slides.indexOf(first));
  thumb.addEventListener('click',()=>{slider.goToTarget(first,false);activate(first);});root.append(thumb);
  const colors={WHITE:'#fff',RED:'#ff2630',BLUE:'#2e46f5',GREEN:'#2ad263',YELLOW:'#ffd92a','ICE BLUE':'#4cd8ff',PURPLE:'#b54fff',ORANGE:'#ff8028',BLACK:'#171717',FLOW:'conic-gradient(#f33,#ffdf32,#41d974,#3686ff,#b45dff,#f33)'};
  const mq=matchMedia('(max-width:900px)');const groups=[];
  for(const index of [config.colorIndex,...(config.bodyMask?[config.bodyIndex]:[])]){
   const native=picker.querySelector(`fieldset[data-index="${index}"]`);if(!native)throw Error('Native preview option missing');
   const field=document.createElement('fieldset');field.dataset.optionIndex=String(index);field.dataset.sillNativeProxy='';
   const legend=document.createElement('legend');legend.textContent=native.querySelector('legend')?.textContent||'';field.append(legend);
   const grid=document.createElement('div');grid.className='lds-v2__color-grid';field.append(grid);
   const values=[...new Set(variants.map(v=>v.options[index]))];
   for(const value of values){
    const button=document.createElement('button');button.type='button';button.className='lds-v2__choice lds-v2__choice--color';button.dataset.optionValue=value;button.setAttribute('aria-label',value);
    const swatch=document.createElement('span');swatch.className='lds-v2__swatch';swatch.style.background=colors[value.toUpperCase()]||'#ddd';
    const label=document.createElement('span');label.textContent=value;button.append(swatch,label);grid.append(button);
    button.addEventListener('click',()=>{
     const current=variants.find(v=>String(v.id)===form.elements.id.value);
     const next=current&&variants.find(v=>v.available&&v.options.every((option,i)=>option===(i===index?value:current.options[i])));
     if(next)picker.selectVariantByID(next.id,false);
    });
   }
   picker.after(field);groups.push({native,field,index});
  }
  let lastPreviewSelection=null;
  const update=()=>{
   const current=variants.find(v=>String(v.id)===form.elements.id.value);if(!current)return;
   const selection=(config.fordSourceSync?current.options:groups.map(group=>current.options[group.index])).join('\u0000');
   if(lastPreviewSelection!==null&&selection!==lastPreviewSelection&&!config.fordSourceSync)thumb.click();
   lastPreviewSelection=selection;
   for(const {field,index}of groups)for(const button of field.querySelectorAll('[data-option-value]')){
    const selected=button.dataset.optionValue===current.options[index];button.classList.toggle('is-selected',selected);button.setAttribute('aria-pressed',String(selected));
    button.disabled=!variants.some(v=>v.available&&v.options.every((option,i)=>option===(i===index?button.dataset.optionValue:current.options[i])));
   }
  };
  const layout=()=>{for(const {native,field}of groups){native.hidden=mq.matches;field.hidden=!mq.matches;}};
  layout();update();mq.addEventListener('change',layout);form.addEventListener('variant:change',update);
  const sticky=document.querySelector(`hdt-sticky-btn-atc[form="${picker.getAttribute('form')}"]`);if(sticky)sticky.dataset.ldsNativeSticky='';
  media.addEventListener('click',event=>{
   if(event.target.closest('button,a,iframe,video'))return;
   const active=event.target.closest('[data-lds-slide]');if(!active?.querySelector('img'))return;
   const zoom=media.querySelector('.lds-sill-zoom-button');if(zoom){event.preventDefault();event.stopImmediatePropagation();zoom.click();}
  },true);
  const engine=document.createElement('script');engine.src=tag.dataset.engineSource;engine.onload=()=>{if(!config.fordSourceSync)thumb.click();};document.head.append(engine);
 };
 initialize().catch(()=>{root.dataset.sillNativeAdapterError='true';});
})();
